import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import { Hub } from 'aws-amplify';
import Routes from '../src/components/routes';
import ReactDOM from 'react-dom';
import { withAuthentication } from '../src/hoc';
import adfsAuth from '../src/utils/adfsAuth';
import '../assets/styles/index.less';
import ApolloProviderWrapper from '../src/components/contexts/ApolloContext';

const App = withAuthentication(Routes)

Hub.listen('auth', (data) => {
    adfsAuth.onAuthEvent(data);
});

const MainApp = () => {
    return (
        <ApolloProviderWrapper>
            <App />
        </ApolloProviderWrapper>
    );
};

ReactDOM.render(<MainApp />, document.getElementById('root'));
